var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { WorkloadAuthService } from './workload-auth.service';
var WorkloadAuthGuardService = /** @class */ (function () {
    function WorkloadAuthGuardService(authService) {
        this.authService = authService;
    }
    WorkloadAuthGuardService.prototype.canActivate = function () {
        var _this = this;
        return this.authService.isUserAuthorised().pipe(tap(function (isAuth) {
            if (!isAuth)
                _this.authService.unAuthUser();
        }));
    };
    WorkloadAuthGuardService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [WorkloadAuthService])
    ], WorkloadAuthGuardService);
    return WorkloadAuthGuardService;
}());
export { WorkloadAuthGuardService };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29ya2xvYWQtYXV0aC1ndWFyZC5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsid29ya2xvYWQtYXV0aC1ndWFyZC5zZXJ2aWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFHM0MsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBRXJDLE9BQU8sRUFBRSxtQkFBbUIsRUFBRSxNQUFNLHlCQUF5QixDQUFDO0FBRzlEO0lBQ0ksa0NBQTBCLFdBQWdDO1FBQWhDLGdCQUFXLEdBQVgsV0FBVyxDQUFxQjtJQUFJLENBQUM7SUFFeEQsOENBQVcsR0FBbEI7UUFBQSxpQkFPQztRQU5HLE9BQU8sSUFBSSxDQUFDLFdBQVcsQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDLElBQUksQ0FDM0MsR0FBRyxDQUFDLFVBQUEsTUFBTTtZQUNOLElBQUksQ0FBQyxNQUFNO2dCQUNQLEtBQUksQ0FBQyxXQUFXLENBQUMsVUFBVSxFQUFFLENBQUM7UUFDdEMsQ0FBQyxDQUFDLENBQ0wsQ0FBQztJQUNOLENBQUM7SUFWUSx3QkFBd0I7UUFEcEMsVUFBVSxFQUFFO3lDQUU4QixtQkFBbUI7T0FEakQsd0JBQXdCLENBV3BDO0lBQUQsK0JBQUM7Q0FBQSxBQVhELElBV0M7U0FYWSx3QkFBd0IifQ==